import React, { type ReactNode } from "react";
import { Flex } from "@chakra-ui/react";
import { NavColumnLabel } from "components/header/nav-column-label";

export function SubNav({ title, children }: { title?: string; children: ReactNode }) {
  return (
    <Flex direction="column" align="start" gap="smallest" py="smaller">
      {title && (
        <NavColumnLabel fontWeight="semibold" color="brand.textSecondary.dark" m={0}>
          {title}
        </NavColumnLabel>
      )}
      {children}
    </Flex>
  );
}
